import { useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import DropZone from "../../components/DropZone";
import * as XLSX from "xlsx";
import { API, graphqlOperation } from "aws-amplify";
import { /* createProductLibProduct , updateProductLibFile */ updateProductLibProduct, createProductLibFile } from '../../graphql/mutations'
import { getProductLibProduct } from '../../graphql/queries'
import DataGrid from "react-data-grid";
import EmptyRowsRenderer from '../../components/EmptyRow'

import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineCloudUpload } from 'react-icons/ai'

import { NotExistProductColumn } from '../../../src/datagrid/columns'
import ModalConfirm from "../../components/ModalConfirm";
import { Link } from "react-router-dom";
import { ProductLibProduct } from "../../API";

interface IExcelInputs {
  excelFile: Array<any>;
}

interface ProductExcel {
  age: number;
  function: any;
  basesize: number;
  barcode_cs: string;
  barcode_ea: string;
  barcode_pac: string;
  brand: string;
  brand_type: string;
  category: string;
  classifier: string;
  collection: string;
  color: string;
  main_image_front: string;
  material_code: string;
  material_name: string;
  subcategory: string;
  tag: any;
  title_en: string;
  title_th: string;
  gallery_image: any;
  // description: string;
  description_en: string;
  description_th: string;
}

function ZoneExcels() {

  const [ uploadProgresses, /* setUploadProgresses */ ] = useState<any>();
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ existsFile, setExistsFile ] = useState<any>([]);
  const [ showDialog, setShowDialog ] = useState<boolean>(false);
  const [ dataForm, setDataForm ] = useState<any>([]);
  const [ showConfirmUpload, setShowConfirmUpload ] = useState<boolean>(false);
  const [ notExistProducts, setNotExistProducts ] = useState<any>([]);
  const [ existProducts, setExistProducts ] = useState<any>([]);
  const acceptedFile = { 'application/vnd.ms-excel': ['.xls', '.xlsx'] }

  const methods = useForm<IExcelInputs>({
    defaultValues: {
      excelFile: [],
    },
  });

  const currentDate = new Date();
  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const {
    // register,
    // watch,
    // setValue,
    control,
    handleSubmit,
  } = methods;

  // const insertProduct = async (data: ProductExcel, barcode: String) => {
  //   let gallery_images = data.gallery_image.split(',')
  //   let galleries:any = []
  //   gallery_images.forEach( (image:string) => {
  //     galleries.push(barcode+"/"+data.material_code+"/packshot/"+image.trim())
  //   });
  //   console.log("gallery_image : ", galleries)
  //   const newProductInput = {
  //     id: barcode+"_"+data.material_code,
  //     brand: data.brand,
  //     brandType: data.brand_type,
  //     materialCode: data.material_code,
  //     barcode: barcode,
  //     name: data.material_name,
  //     titleEN: data.title_en,
  //     titleTH: data.title_th,
  //     category: data.category,
  //     subcategory: data.subcategory,
  //     collection: data.collection,
  //     color: data.color,
  //     classifier: data.classifier,
  //     description: data.des,
  //     descriptionEN: data.desEN,
  //     descriptionTH: data.desTH,
  //     functions: JSON.stringify(data.function.split(' ')),
  //     width: 1.0,
  //     length: 1.0,
  //     weight: 1.0,
  //     height: 1.0,
  //     weightUnit: "G",
  //     images: JSON.stringify(galleries),
  //     tags: JSON.stringify(data.tag.split(',')),
  //     lastUpdatedDate: formatDate(currentDate),
  //   };
  //   console.log("newProductInput ; ", newProductInput)
  //   const productLibResponse: any = await API.graphql(
  //     graphqlOperation(createProductLibProduct, {
  //       input: { ...newProductInput },
  //     })
  //   );
  //   console.log("productLibResponse : ", productLibResponse)
  // }

  const checkExistProduct = async (data: ProductExcel) => {
    // console.log("data : ", data)
    let notExistProduct = [] /* Collect not exist product*/

    /* check exists barcode_ea */
    if (data.barcode_ea) {
      const advID_ea = data.barcode_ea+"_"+data.material_code
      const productLibResponseEA: any = await API.graphql(
        graphqlOperation(getProductLibProduct, {limit: 1, id:advID_ea})
      );
      const productEA = productLibResponseEA.data.getProductLibProduct

      if (productEA) {
        updateProduct(data, data.barcode_ea)
        if (productEA.files.items.length <= 0 && data.gallery_image) {
          createProductFiles(data, data.barcode_ea, productEA)
        } else if (!data.gallery_image) {
          console.log("Don't have gallery_image !!!!")
        } else {
          // will update files ??????
          // if (data.gallery_image) updateProductFiles(data, data.barcode_ea, productEA)
          console.log("Will update productFiles ????")
        }
      } else {
        // insertProduct(data, data.barcode_ea)
        notExistProduct.push("barcode_ea")
      }
    }

    /* check exists barcode_cs */
    if (data.barcode_cs) {
      const advID_cs = data.barcode_cs+"_"+data.material_code
      const productLibResponseCS: any = await API.graphql(
        graphqlOperation(getProductLibProduct, {limit: 1, id:advID_cs})
      );
      const productCS = productLibResponseCS.data.getProductLibProduct
      
      if (productCS) {
        updateProduct(data, data.barcode_cs)
        if (productCS.files.items.length <= 0 && data.gallery_image) {
          createProductFiles(data, data.barcode_cs, productCS)
        } else if (!data.gallery_image) {
          console.log("Don't have gallery_image !!!!")
        } else {
          // will update files ??????
          // if (data.gallery_image) updateProductFiles(data, data.barcode_cs, productCS)
          console.log("Will update productFiles ????")
        }
      } else {
        // insertProduct(data, data.barcode_cs)
        notExistProduct.push("barcode_cs")
      }
    }

    /* check exists barcode_pac */
    if (data.barcode_pac) {
      const advID_pac = data.barcode_pac+"_"+data.material_code
      const productLibResponsePAC: any = await API.graphql(
        graphqlOperation(getProductLibProduct, {limit: 1, id:advID_pac})
      );
      const productPAC = productLibResponsePAC.data.getProductLibProduct
      
      if (productPAC) {
        updateProduct(data, data.barcode_pac)
        if (productPAC.files.items.length <= 0 && data.gallery_image) {
          createProductFiles(data, data.barcode_pac, productPAC)
        } else if (!data.gallery_image) {
          console.log("Don't have gallery_image !!!!")
        } else {
          // will update files ??????
          // if (data.gallery_image) updateProductFiles(data, data.barcode_pac, productPAC)
          console.log("Will update productFiles ????")
        }
      } else {
        // insertProduct(data, data.barcode_pac)
        notExistProduct.push("barcode_pac")
      }
    }

    return notExistProduct
  }

  const updateProduct = async (data: ProductExcel, barcode: String) => {

    const updateProductInput: any = {
      id: barcode+"_"+data.material_code,
      name: data.material_name,
      titleEN: data.title_en,
      titleTH: data.title_th,
      category: data.category,
      subcategory: data.subcategory,
      collection: data.collection,
      color: data.color,
      classifier: data.classifier,
      baseSize: data.basesize,
      // brand: data.brand,
      // brandType: data.brand_type,
      // materialCode: data.material_code,
      // barcode: barcode,
      // width: 1.0,
      // length: 1.0,
      // weight: 1.0,
      // height: 1.0,
      // weightUnit: "G",
      // description: data.des,
      descriptionEN: data.description_en,
      descriptionTH: data.description_th,
      // functions: functions,
      // images: JSON.stringify(cover),
      // tags: JSON.stringify(data.tag.split(','))
      lastUpdatedDate: formatDate(currentDate),
    };

    /* if data.main_image_front exists */
    if (data.main_image_front) {
      const cover = [ barcode+"/"+data.material_code+"/cover/"+data.main_image_front.trim() ]
      updateProductInput['images'] = JSON.stringify(cover)
    }

    /* if data.function exists */
    if (data.function) {
      const functions = data.function ? JSON.stringify(data.function.split(' ')) : JSON.stringify([])
      updateProductInput['functions'] = functions
    }

    /* if data.tag exists */
    if (data.tag) {
      const tags = data.tag ? JSON.stringify(data.tag.split(',')) : JSON.stringify([])
      updateProductInput['tags'] = tags
    }

    console.log("updateProductInput : ", updateProductInput)
    await API.graphql(
      graphqlOperation(updateProductLibProduct, {
        input: { ...updateProductInput },
      })
    );
  }

  const createProductFiles = async (data: ProductExcel, barcode: String, product: ProductLibProduct) => {
    let gallery_images = data.gallery_image.split(',')
    let galleries:any = []
    gallery_images.forEach( (image:string) => {
      galleries.push(barcode+"/"+data.material_code+"/packshot/"+image.trim())
    });
    console.log("galleries : ", galleries)

    for await (const gallery of galleries) {
      const sp_gallery = gallery.split('_')
      const mediaTypeSub = sp_gallery[sp_gallery.length - 1].includes("F.") ? "FRONT" : "BACK"
      const functions = data.function ? JSON.stringify(data.function.split(' ')) : JSON.stringify([])

      const paramProductFileInput = {
        productLibProductFilesId: product.id,
        brand: product.brand ? product.brand : data.brand,
        brandType: product.brandType ? product.brandType : data.brand_type,
        materialCode: product.materialCode ? product.materialCode : data.material_code,
        materialName: product.materialName ? product.materialName : data.material_name,
        barcode: barcode,
        productHierachy: product.productHierachy ? product.productHierachy : "",
        mediaType: "PACKSHOT",
        mediaTypeSub: mediaTypeSub,
        name: data.material_name,
        titleEN: data.title_en,
        titleTH: data.title_th,
        category: data.category,
        subcategory: data.subcategory,
        collection: data.collection,
        color: data.color,
        classifier: data.classifier,
        status: product.status ? product.status : "",
        width: product.width ? product.width : 1.0,
        length: product.length ? product.length : 1.0,
        weight: product.weight ? product.weight : 1.0,
        height: product.height ? product.height : 1.0,
        weightUnit: product.weightUnit ? product.weightUnit : "G",
        // description: data.des,
        descriptionEN: data.description_en,
        descriptionTH: data.description_th,
        functions: functions,
        path: gallery,
        tags: JSON.stringify(data.tag ? data.tag.split(','): [])
      };
      console.log("paramProductFileInput : ", paramProductFileInput)
      await API.graphql(
        graphqlOperation(createProductLibFile, {
          input: { ...paramProductFileInput },
        })
      );
    }
  }

  // const updateProductFiles = async (data: ProductExcel, barcode: String, product: ProductLibProduct) => {
  //   let gallery_images = data.gallery_image.split(',')
  //   let galleries:any = []
  //   gallery_images.forEach( (image:string) => {
  //     galleries.push(barcode+"/"+data.material_code+"/cover/"+image.trim())
  //   });
  //   console.log("galleries : ", galleries)

  //   for await (const gallery of galleries) {
  //     const sp_gallery = gallery.split('_')
  //     const mediaTypeSub = sp_gallery[sp_gallery.length - 1].includes("F.") ? "FRONT" : "BACK"
  //     const functions = data.function ? JSON.stringify(data.function.split(' ')) : JSON.stringify([])

  //     const paramProductFileInput = {
  //       productLibProductFilesId: product.id,
  //       brand: product.brand ? product.brand : data.brand,
  //       brandType: product.brandType ? product.brandType : data.brand_type,
  //       materialCode: product.materialCode ? product.materialCode : data.material_code,
  //       materialName: product.materialName ? product.materialName : data.material_name,
  //       barcode: barcode,
  //       productHierachy: product.productHierachy ? product.productHierachy : "",
  //       mediaType: "PACKSHOT",
  //       mediaTypeSub: mediaTypeSub,
  //       name: data.material_name,
  //       titleEN: data.title_en,
  //       titleTH: data.title_th,
  //       category: data.category,
  //       subcategory: data.subcategory,
  //       collection: data.collection,
  //       color: data.color,
  //       classifier: data.classifier,
  //       status: product.status ? product.status : "",
  //       width: product.width ? product.width : 1.0,
  //       length: product.length ? product.length : 1.0,
  //       weight: product.weight ? product.weight : 1.0,
  //       height: product.height ? product.height : 1.0,
  //       weightUnit: product.weightUnit ? product.weightUnit : "G",
  //       // description: data.des,
  //       // descriptionEN: data.description_en,
  //       // descriptionTH: data.description_th,
  //       functions: functions,
  //       path: gallery,
  //       tags: JSON.stringify(data.tag.split(','))
  //     };
  //     await API.graphql(
  //       graphqlOperation(updateProductLibFile, {
  //         input: { ...paramProductFileInput },
  //       })
  //     );
  //   }
  // }

  const onSubmit = async (data: any) => {

    /* Initialize data */
    setExistProducts([])
    setNotExistProducts([])

    const excelFile = data.excelFile
    console.log("excelFile : ", excelFile[0])
    
    /* Ref. https://stackoverflow.com/questions/46909260/reading-excel-file-in-reactjs */ 
    const fileReader = new FileReader();
    let localNotExistProducts: any = []
    let localExistProducts: any = []
    fileReader.readAsArrayBuffer(excelFile[0]);
    fileReader.onload = async (e) => {
      const bufferArray = e.target?.result;

      const wb = XLSX.read(bufferArray, { type: "buffer" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const datas:ProductExcel[] = XLSX.utils.sheet_to_json(ws);

      for await (const data of datas) {
        const notExistProduct = await checkExistProduct(data)
        const productObj = {
          material_code: data.material_code,
          material_name: data.material_name,
          barcode_ea: data.barcode_ea,
          barcode_cs: data.barcode_cs,
          barcode_pac: data.barcode_pac,
        }
        if (notExistProduct.length > 0) {
          localNotExistProducts.push(productObj)
        } else {
          localExistProducts.push(productObj)
        }
      }

      if (localNotExistProducts.length > 0) {
        setShowDialog(true)
        setNotExistProducts(localNotExistProducts)
        setExistProducts(localExistProducts)
        console.log("trigger")
      } else {
        setShowDialog(true)
        setExistProducts(localExistProducts)
        console.log("trigger else")
      }
    };

    // const f = await (await fetch("https://sheetjs.com/pres.xlsx")).arrayBuffer();
    // const wb = readFile(excelFile[0].path);
    // const dataExcel = utils.sheet_to_json<President>(wb.Sheets[wb.SheetNames[0]]);
    // console.log(dataExcel);
  };

  const onTriggerConfirmSubmitModal = (data: any) => {
    setDataForm(data)
    setShowConfirmUpload(true)
  }

  return (
    <>
      <ModalConfirm show={showDialog}
        onHide={() => {}}
        title='Result upload product'
        cancelText={'Close'}
        cancelAction={() => {
          setShowDialog(false)
          setShowConfirmUpload(false)
          setIsLoading(false)
        }}
        okClass='btn-submit'
        maxWidth='max-w-4xl'
      >
        <>
          { existProducts.length > 0 ? 
            <>
              <div className='flex flex-col items-center justify-center mb-2 space-y-2 text-center'>
                <AiOutlineCheckCircle size={36} color="green"/>
                <h6>The list of products has been updated</h6>
              </div>
              <DataGrid
                columns={NotExistProductColumn}
                rows={existProducts}
                renderers={{ noRowsFallback: <EmptyRowsRenderer/> }}
                style={{ height: '20vh' }}
              />
            </> : <></>
          }
          { notExistProducts.length > 0 ? 
            <>
              <div className='flex flex-col items-center justify-center my-2 space-y-2 text-center'>
                <AiOutlineCloseCircle size={36} color="red"/>
                <h6>List of products that are not update !!!</h6>
              </div>
              <DataGrid
                columns={NotExistProductColumn}
                rows={notExistProducts}
                renderers={{ noRowsFallback: <EmptyRowsRenderer/> }}
                style={{ height: '20vh' }}
              />
            </> : <></>
          }
        </>
      </ModalConfirm>

      <ModalConfirm show={showConfirmUpload}
        onHide={() => {}}
        title='Upload confirmation !!'
        cancelText={'Close'}
        cancelAction={() => setShowConfirmUpload(false)}
        okText={'Confirm'}
        loading={isLoading}
        okAction={() => {
          onSubmit(dataForm)
          setIsLoading(true)
        }}
        okClass='btn-submit'
        maxWidth='max-w-md'
      >
        <>
          <div className='flex flex-col items-center justify-center mb-2 space-y-2 text-center'>
            <AiOutlineCloudUpload size={36} color="#22c55e"/>
            <h6>Do you want to upload product excel file ?</h6>
          </div>
        </>
      </ModalConfirm>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onTriggerConfirmSubmitModal)}>
          <p className="pb-2">
            Template file import
            <span className="relative m-1 italic font-bold text-blue-500 group">
              <Link to="/template_import.xlsx" target="_blank" download>
                Download
              </Link> 
              <span className="absolute left-0 w-0 h-1 transition-all bg-blue-300 -bottom-1 group-hover:w-full"></span> 
            </span>
          </p>
          <p> Please Upload only one excel file ! </p>
          <div className="justify-center px-6 py-3 text-center">
            <div className="justify-center text-center">
              <Controller
                render={({ field: { onChange } }) => (
                  <DropZone
                    multiple={false}
                    onChange={(files: any) => {
                      onChange(files)
                      setExistsFile(files)
                    }}
                    onDrop={(files: any) => {
                      // setIsUploadDone(false);
                    }}
                    progress={uploadProgresses}
                    isUploadDone={isLoading}
                    accept={acceptedFile}
                  />
                )}
                name="excelFile"
                control={control}
              />
            </div>
          </div>

          <div className="flex flex-row justify-center gap-2 mt-2">
            <button
              disabled={existsFile.length !== 1}
              onClick={()=>{}}
              className="btn-submit"
              type="submit"
            >
              UPLOAD
            </button>
          </div>
        </form>
      </FormProvider>
    </>
  );
}

export default ZoneExcels;
